<script lang="ts">
	import Switch from '$lib/components/atoms/switch/Switch.svelte';
	import * as m from '$paraglide/messages';

	interface Props {
		checked?: boolean;
		onChange?: (checked: boolean) => void;
	}

	let { checked = $bindable(false), onChange }: Props = $props();
</script>

<div class="p-block-2 text-body text-md text-coloredneutral">
	<Switch
		id="withCaravan"
		text={m.itinerary__options__caravan_toggle()}
		bind:checked
		onchange={() => {
			onChange?.(checked);
		}}
		helperTextProps={{
			text: m.itinerary__options__caravan_toggle_helper_text(),
		}}
	/>
</div>
